<template>
  <div class="photo-gallery" id="photo-gallery-wrapper" tabindex="0">
    <div class="images-wrapper product-single-gallery" @click="openGallery()">
      <Photo :src="items[0]" class="image" :key="1" />
      <span class="search-icon" @click="openGallery()" v-if="fullscreenEnabled">
        <i class="fa fa-search-plus" />
      </span>
    </div>
    <cool-light-box :items="items" :index="index" :loop="true" @close="index = null">
    </cool-light-box>
    <div class="images-wrapper">
      <div
        class="image"
        v-for="(image, imageIndex) in items"
        :id="`image-id-${imageIndex}`"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{ height: '100px', width: '100px' }"
      >
        <Photo :src="image" />
      </div>
    </div>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

import Photo from '@/components/shared/Image.vue';

export default {
  name: 'PhotoGallery',
  props: {
    gallery: Array,
    fullscreenEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CoolLightBox,
    Photo,
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    items() {
      return this.gallery?.map((item) => item.src);
    },
  },
  methods: {
    openGallery() {
      $('#image-id-0').click();
    },
  },
};
</script>
<style lang="scss" scoped>
.product-single-gallery {
  position: relative;
  cursor: pointer;

  .search-icon {
    position: absolute;
    width: 5rem;
    right: 50%;
    bottom: 50%;
    display: flex;
    justify-content: center;
    color: #a0a0a0;
    font-size: 5rem;
    opacity: 0;
    transition: opacity 0.5s;

    i {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 20%;
    }
  }

  &:hover {
    .search-icon {
      opacity: 1;
    }
  }
}

.images-wrapper div {
  cursor: pointer;
}
</style>

<style lang="scss">
// @media (min-width: 992px) {
//   .modal-dialog {
//     max-width: 100%;
//     width: 100%;
//   }
// }

.images-wrapper {
  display: flex;
}
</style>
